<template>
  <div class="ml-3">
    <h2>API Keys</h2>
    <el-table
      :data="apiKeys"
      style="width: 100%"
    >
      <el-table-column
        prop="application"
        label="Application"
        width="120px"
      />
      <el-table-column
        prop="username"
        label="Username"
      />
      <el-table-column
        prop="key"
        label="API Key"
      />
    </el-table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      apiKeys: [
        {
          'application': 'FreshDesk',
          'username': this.$user.instance.email,
          'key': this.$user.instance.freshdesk_key
        }
      ]
    }
  }
}
</script>
